import { useEffect, useRef } from "react";

// Reusable: smoothly scrolls the attached element into view whenever `trigger`
// changes to a truthy value. Used by the Experience Mode flows so uploading /
// processing / result steps auto-scroll into view. Reuse anywhere else too.
//
//   const ref = useAutoScroll(stage);
//   <div ref={ref}>…</div>
export default function useAutoScroll(trigger, { behavior = "smooth", block = "start", delay = 80 } = {}) {
  const ref = useRef(null);
  useEffect(() => {
    if (trigger == null || trigger === false) return undefined;
    const id = setTimeout(() => {
      ref.current?.scrollIntoView({ behavior, block });
    }, delay);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);
  return ref;
}
